import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { fetchJson } from '@ceramicnetwork/common';
export var RemotePinApi = /*#__PURE__*/function () {
  function RemotePinApi(_apiUrl) {
    _classCallCheck(this, RemotePinApi);
    this._apiUrl = _apiUrl;
  }
  _createClass(RemotePinApi, [{
    key: "add",
    value: function () {
      var _add = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(streamId, force) {
        var args;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              args = {};
              if (force) {
                args.force = true;
              }
              _context.next = 4;
              return fetchJson(this._apiUrl + '/pins' + "/".concat(streamId.toString()), {
                method: 'post',
                body: args
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function add(_x, _x2) {
        return _add.apply(this, arguments);
      }
      return add;
    }()
  }, {
    key: "rm",
    value: function () {
      var _rm = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(streamId, opts) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return fetchJson(this._apiUrl + '/pins' + "/".concat(streamId.toString()), {
                method: 'delete',
                body: {
                  opts: opts
                }
              });
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function rm(_x3, _x4) {
        return _rm.apply(this, arguments);
      }
      return rm;
    }()
  }, {
    key: "ls",
    value: function () {
      var _ls = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(streamId) {
        var url, result, pinnedStreamIds;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              url = this._apiUrl + '/pins';
              if (streamId) {
                url += "/".concat(streamId.toString());
              }
              _context3.next = 4;
              return fetchJson(url);
            case 4:
              result = _context3.sent;
              pinnedStreamIds = result.pinnedStreamIds;
              return _context3.abrupt("return", _defineProperty({}, Symbol.asyncIterator, function () {
                var index = 0;
                return {
                  next: function next() {
                    if (index === pinnedStreamIds.length) {
                      return Promise.resolve({
                        value: null,
                        done: true
                      });
                    }
                    return Promise.resolve({
                      value: pinnedStreamIds[index++],
                      done: false
                    });
                  }
                };
              }));
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function ls(_x5) {
        return _ls.apply(this, arguments);
      }
      return ls;
    }()
  }]);
  return RemotePinApi;
}();